// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.flash-container {
  position: absolute;
  top: 0;
  width: 100%;
  height: 56px;
  color: #fff;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.dismiss {
  position: absolute;
  bottom: 0;
  margin: 0 0 5px 0;
  font-size: 0.7em;
  opacity: 0.5;
}

.success {
  color: #3c763d;
  background-color: #dff0d8;
  border-color: #d6e9c6;
}

.info {
  color: #31708f;
  background-color: #d9edf7;
  border-color: #bce8f1;
}

.warning {
  color: #8a6d3b;
  background-color: #fcf8e3;
  border-color: #faebcc;
}

.danger {
  color: #a94442;
  background-color: #f2dede;
  border-color: #ebccd1;
}`, "",{"version":3,"sources":["webpack://./src/app/components/flash/flash.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AACF;;AAEA;EACE,kBAAA;EACA,SAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;AACF;;AAEA;EACE,cAAA;EACA,yBAAA;EACA,qBAAA;AACF;;AAEA;EACE,cAAA;EACA,yBAAA;EACA,qBAAA;AACF;;AAEA;EACE,cAAA;EACA,yBAAA;EACA,qBAAA;AACF;;AAEA;EACE,cAAA;EACA,yBAAA;EACA,qBAAA;AACF","sourcesContent":[".flash-container {\n  position: absolute;\n  top: 0;\n  width: 100%;\n  height: 56px;\n  color: #fff;\n  z-index: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.dismiss {\n  position: absolute;\n  bottom: 0;\n  margin: 0 0 5px 0;\n  font-size: 0.7em;\n  opacity: 0.5;\n}\n\n.success {\n  color: #3c763d;\n  background-color: #dff0d8;\n  border-color: #d6e9c6;\n}\n\n.info {\n  color: #31708f;\n  background-color: #d9edf7;\n  border-color: #bce8f1;\n}\n\n.warning {\n  color: #8a6d3b;\n  background-color: #fcf8e3;\n  border-color: #faebcc;\n}\n\n.danger {\n  color: #a94442;\n  background-color: #f2dede;\n  border-color: #ebccd1;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
